module.exports = require("./ru-MD");